<div class="item-validation">
  <mart-container
    title="Verify your Email"
    subTitle="Please verify your email address to continue."

  >
    <mart-form-builder>
      <div class="validate">

        <mart-form-content
          [type]="formContent.button"
          label="Verify"
          name="arrow-forward-outline"
          [style.width]="'30%'"
          [disable]="isLoading"
          (click)="processForm()"
        />
      </div>
    </mart-form-builder>
  </mart-container>
</div>
